import "./index.css"; // Assuming you have a CSS file for styling

import React, { useState } from "react";
const SettlmentTextBtn = ({ value }) => {
  const [showTooltip, setShowTooltip] = useState(true);

  const options = [
    {
      option: "paid",
      tooltip: "تسویه شده",
      className: "text-success-60 bg-success-10 rounded-md px-[10px] py-1 w-fit mx-auto",
    },
    {
      option: "submitted",
      tooltip: "آماده تسویه",
      className: "text-secondary-90 bg-[#CED3D9] rounded-md px-[10px] py-1 min-w-[100px] w-fit mx-auto",
    },
    {
      option: "pending_for_settlement",
      tooltip: "درانتظار تسویه",
      className: "text-secondary-90 bg-[#CED3D9] rounded-md px-[10px] py-1 min-w-[100px] w-fit mx-auto",
    },
  ];

  const item = options.find((entry) => entry.option === value);
  const tooltip = item ? item.tooltip : "*";
  const className = item ? item.className : "*";

  return <div className={className}>{tooltip}</div>;
};

export default SettlmentTextBtn;
